import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import Lottie from 'lottie-react';
import { motion } from 'framer-motion';
import homepageBackground from '../assets/homepage1a.webp';
import atomsAnimation2 from '../assets/Animation_1736003383425.json';
import axios from 'axios';

const HomepageBanner = () => {
  const [college, setCollege] = useState(null);
  const [courses, setCourses] = useState([]);
  const [displayname, setDisplayname] = useState(null); // Store the username
  const [error, setError] = useState(null);




    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        setDisplayname(user.displayname);
      }
    }, []);

  // Check for logged-in user and get the collegeId from the JWT token
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user')); // Get user details from localStorage
    const token = localStorage.getItem('token'); // Get the JWT token

    if (user && token) {
      const collegeId = user.collegeId; // Extract collegeId from user data
      const courseIds = user.courseIds; // Extract courseId from user data

     
      // Check if collegeId exists
      if (!collegeId) {
        setError('No collegeId found for the logged-in user.');
        return;
      }

      // Fetch the college details from the backend
      axios
        .get(`https://backend.scholarkart.in/api/colleges/${collegeId}`)  // Fetch college details by collegeId
        .then((response) => {
          setCollege(response.data);  // Set the fetched college data to state
        })
        .catch((error) => {
          setError('Error fetching college details: ' + error.message);
        });




        if (courseIds && courseIds.length > 0) {
          const courseIdsParam = courseIds.join(','); // Convert array to a comma-separated string
        
          axios
            .get(`https://backend.scholarkart.in/api/courses?courseIds=${courseIdsParam}`)
            .then((response) => {
              setCourses(response.data); // Set the fetched courses data (array)
            })
            .catch((error) => {
              setError('Error fetching course details: ' + error.message);
            });
        } else {
          setError('No courseId found for the logged-in user.');
        }

        


    } else {
      setError('User is not logged in');
    }
  }, []);



  return (

      <Box
        sx={{
          position: 'relative',
          zIndex: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          height: '100%',
          textAlign: 'left',
          paddingLeft: '20px',
        }}
      >
          <Typography
            variant="h7"
            sx={{
              fontWeight: 'bold',
              marginBottom: '6px',
            }}
          >
            You are currently enrolled at<br />
            <Typography
              component="span"
              variant="h5"
              sx={{ 
                color: 'darkblue', 
                fontWeight: 'bold',
              }}
            >
              {college ? college.collegeName : 'College Name'} {/* Dynamically display college name */}
              ({college ? college.collegeCode : 'College ID'}) {/* Dynamically display college ID */}
            </Typography>
          </Typography>


            <Typography
              variant="h7"
              sx={{
                marginBottom: '24px',
                width: {
                  xs: '90%',
                  sm: '70%',
                  md: '45%',
                },
              }}
            >
              {college ? college.address : 'College Address'} {/* Dynamically display address */}
            </Typography>


       <Typography variant="h4" sx={{ marginBottom: 2 }}>
         📚 Course: 
            {courses.length > 0
            ? courses.map((course, index) => (
                <span key={course._id}>
                  {course.courseName}
                  {index < courses.length - 1 ? ', ' : ''}
                </span>
              ))
            : 'Course Name'}
            </Typography>


      </Box>

    
  );
};
export const getUserDetails = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user) {
    return {
      displayName: user.displayname || "Unknown User",
      collegeId: user.collegeId || null,
      courseIds: user.courseIds || [],
    };
  }
  return null;
};
export default HomepageBanner;

